<script>
  const POEMS = [
    [
      "Silti",
      " aivan",
      " kuin",
      " onnettomuus",
      "\nolisi",
      " levinnyt",
      " mieltymyksiäni",
      " pitkin",
      "\nja",
      " vain",
      " mineriittiä",
      " ja",
      " meteli",
      " jäänyt",
      "\nsiihen",
      ", mistä",
      " kärsivällisyys",
      " lähti",
    ],
    [
      "Jo",
      " nyt",
      " joenuomassa",
      " omituinen",
      "\nystävyys",
      " syvenee",
      ": heikkoudet",
      " uppoavat",
      "\nja",
      " kimmeltävä",
      ", kevein",
      " jää",
      " pintaan",
      "\nSaa",
      " selvitä",
      " ja",
      " jäädä",
      " kellumaan",
      " pintaan",
    ],
    [
      "Kun",
      " polku",
      " oli",
      " turvallisesti",
      " ummessa",
      "\nilkeämielisyys",
      " suli",
      " ja",
      " suli",
      "\nmyös",
      " varmuus",
      " siitä",
      ", että",
      " ovi",
      " joka",
      " lahosi",
      "\npiti",
      " ulkona",
      " myrskyt",
      ", ei",
      " minut",
    ],
    [
      "Lähemmäs",
      ", hitaammin",
      ", aaveet",
      "\neivät",
      " yletä",
      " neuvomaan",
      " jos",
      " toiveet",
      "\neivät",
      " hetkeksikään",
      " hellitä",
      " huomiotaan",
      "\nmeistä",
      " ja",
      " loittone",
      " pois",
      "\nRakkaudesta",
      ", kärsivällisyydestä",
      " aaveet",
      "\nsanokaa",
      " jotakin",
      " jo",
    ],
  ];

  const MAX_LENGTH = POEMS.reduce(
    (soFar, cur) => (cur.length > soFar ? cur.length : soFar),
    0
  );

  let day = 1;
  let activePoem = 0;

  // For hacking workaround for Safari render bug
  let renderCount = 0;

  $: text = POEMS[activePoem].slice(0, day).join("");

  function gotoDay(value) {
    day = value;
    renderCount++;
  }

  function prevDay() {
    if (day > 1) {
      day -= 1;
      renderCount++;
    }
  }

  function nextDay() {
    if (day < MAX_LENGTH) {
      day += 1;
      renderCount++;
    }
  }

  function gotoPoem(value) {
    activePoem = value;
    renderCount++;
  }

  function prevPoem() {
    if (activePoem > 0) {
      activePoem -= 1;
      renderCount++;
    }
  }

  function nextPoem() {
    if (activePoem < POEMS.length - 1) {
      activePoem += 1;
      renderCount++;
    }
  }

  function handleKeydown(event) {
    switch (event.key) {
      case "ArrowUp":
        event.preventDefault();
        prevPoem();
        break;

      case "ArrowDown":
        event.preventDefault();
        nextPoem();
        break;

      case "ArrowLeft":
        event.preventDefault();
        prevDay();
        break;

      case "ArrowRight":
        event.preventDefault();
        nextDay();
        break;

      default:
        break;
    }
  }
</script>

<svelte:window on:keydown={handleKeydown} />

<main>
  <div class="controls">
    <header class="header-area">
      <div
        on:click={() => gotoDay(1)}
        class="day-changer pseudo-button"
        role="button"
        class:disabled={day < MAX_LENGTH}
      >
        {"«"}
      </div>
      <div
        on:click={prevDay}
        class="day-changer pseudo-button"
        role="button"
        class:disabled={day <= 1}
      >
        {"‹"}
      </div>
      <h1>{day}. päivä</h1>
      <div
        on:click={nextDay}
        class="day-changer pseudo-button"
        role="button"
        class:disabled={day >= MAX_LENGTH}
      >
        {"›"}
      </div>
      <div class="day-changer pseudo-button disabled">
        {" "}
      </div>
    </header>
  </div>
  <div class="poem-wrapper">
    <div class="poem-menu">
      {#each POEMS as poem, idx}
        <div
          class="menu-item bgcol-{idx + 1} pseudo-button"
          class:menu-item--selected={activePoem === idx}
          role="button"
          on:click={() => gotoPoem(idx)}
        >
          {idx + 1}
        </div>
      {/each}
    </div>
    <div
      class="poem bgcol-{activePoem + 1}"
      class:safari-repaint-hack={renderCount % 2}
    >
      {text}
    </div>
  </div>
</main>

<style>
  main {
    padding: 1em;
    max-width: 600px;
    margin: 0 auto;
    font-size: 20px;
    line-height: 2;
  }
  .header-area {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2rem 0 1rem;
  }
  h1 {
    color: #666;
    font-size: inherit;
    font-weight: normal;
    margin: 0 1rem;
    width: 7em;
    text-align: center;
  }
  .pseudo-button {
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
  }
  .pseudo-button.disabled {
    cursor: default;
    opacity: 0;
  }
  .day-changer {
    padding: 0 1rem;
    font-size: 1.5rem;
  }
  .poem-wrapper {
    display: flex;
    flex-direction: row;
  }
  .menu-item {
    padding: 1rem 1rem;
    margin-bottom: 1rem;
    transition: all cubic-bezier(0.215, 0.61, 0.355, 1) 0.1s;
  }
  .safari-repaint-hack {
    opacity: 0.999999;
  }
  .menu-item--selected {
    margin-left: -1rem;
    margin-right: 0;
    padding-right: 2rem;
    position: relative;
    z-index: 1;
  }
  .bgcol-1 {
    background: var(--bg1);
  }
  .bgcol-2 {
    background: var(--bg2);
  }
  .bgcol-3 {
    background: var(--bg3);
  }
  .bgcol-4 {
    background: var(--bg4);
  }
  .poem {
    flex: 0 0 25em;
    display: block;
    white-space: pre;
    min-height: 15em;
    letter-spacing: 0.025em;
    line-height: 3rem;
    padding: 3rem 2em;
    box-shadow: 0px 2px 3px #00000025;
    transition: background-color cubic-bezier(0.215, 0.61, 0.355, 1) 0.1s;
  }
  @media (max-width: 700px) {
    main {
      font-size: 18px;
    }
    .header-area {
      margin-bottom: 3rem;
    }
    .poem-wrapper {
      flex-direction: column;
    }
    .poem-menu {
      display: flex;
    }
    .menu-item {
      flex-grow: 1;
      line-height: 1;
      min-width: 30px;
      text-align: center;
      margin: 0;
      padding: 1rem;
      box-shadow: 0px -1px 3px #00000025;
    }
    .menu-item:not(:last-child) {
      margin-right: 1rem;
    }
    .menu-item--selected {
      margin-top: -1rem;
      margin-bottom: 0;
      padding-right: 1rem;
    }
    .menu-item--selected:after {
      content: "";
      display: block;
      position: absolute;
      background: inherit;
      left: 0;
      right: 0;
      bottom: -5px;
      height: 10px;
    }
    .poem {
      flex: initial;
      box-shadow: 0px -1px 3px #00000025;
      padding: 2em;
      min-height: 16em;
    }
    @media (max-width: 550px) {
      main {
        font-size: 16px;
      }
      .poem {
        min-height: 20em;
      }
    }
    @media (max-width: 400px) {
      main {
        font-size: 14px;
      }
      .poem {
        padding: 1em;
      }
    }
  }
</style>
